import { Modal } from "antd";

export type CsvErrorPayload = {
  message?: string;
};

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

const toStringValue = (value: unknown): string | undefined =>
  typeof value === "string" ? value : undefined;

export const parseCsvErrorPayload = async (response: Response): Promise<CsvErrorPayload | undefined> => {
  try {
    const data = await response.clone().json();
    if (!isRecord(data)) return undefined;

    const message = toStringValue(data.message);

    if (!message) {
      return undefined;
    }

    return { message };
  } catch (_error) {
    console.warn('Failed to parse response')
    return undefined;
  }
};

export const showCsvUploadErrorModal = (
  fileName: string,
  payload?: CsvErrorPayload,
  fallbackMessage?: string
) => {
  const title = payload?.message ?? fallbackMessage ?? `${fileName}のアップロードに失敗しました`;

  Modal.error({
    centered: true,
    title,
  });
};
